import { Base } from "../../framework/base";
import { EmployeeGroupItem, IEmployeeGroupItem } from "./employeeGroupItem";

export interface IEmployeeGroupItems {
    items: IEmployeeGroupItem[];
    hasMore: boolean;
    page: number;
}

export class EmployeeGroupItems implements IEmployeeGroupItems {
    items: EmployeeGroupItem[];
    hasMore: boolean;
    page: number;

    constructor();
    constructor(obj: IEmployeeGroupItems);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.items = Base.getTypedArray<EmployeeGroupItem>(obj ? obj.items : null, EmployeeGroupItem);
    }
}